<template>
<div>
    <rkm-form
        ref="Form"
        show-legend
    >

        <rkm-area
            title="Laboratório"
            type="fieldset"
        >

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="data.form.unidades"
                        label="Laboratório"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="item.unidadeId"
                        disabled
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        textField="nome"
                        v-model="item.infraestruturaId"
                        disabled
                        valueField="id"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Tipo"
                        v-model="item.cotaTipoNome"
                        disabled
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1" v-show="item.cotaTipoId == enums.tipoCota.QUANTIDADE">
                    <rkm-form-input
                        label="Cota"
                        v-model="item.cotaQuantidade"
                        number
                        disabled
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1" v-show="item.cotaTipoId != enums.tipoCota.QUANTIDADE">
                    <rkm-form-input
                        label="Cota"
                        ref="cotaValor"
                        v-model="item.cotaValor"
                        v-money="money"
                        prepend="R$"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Período de"
                        end-label="Até"
                        v-model="model.periodo"
                        disabled
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-row>

            <rkm-col
                cols="12"
            >
                <rkm-area
                    :title="checkHandleAlter ? 'Alterar cota - Unidade Solicitante' : 'Cadastrar cota - Unidade Solicitante'"
                    type="fieldset"
                >

                    <rkm-row>

                        <rkm-col cols="4">
                            <rkm-form-select
                                :options="data.form.unidades"
                                :validations="validations.unidadeSolicitante"
                                label="Unidade Solicitante"
                                show-default-option
                                text-field="nomeFantasia"
                                v-model="unidadeSolicitante.unidadeSolicitanteId"
                                :disabled="isReadOnly ? true : false"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-select
                                label="Local de atendimento"
                                :options="infraestruturasSolicitante"
                                :validations="validations.infraestruturasSolicitante"
                                textField="nome"
                                v-model="unidadeSolicitante.infraestruturaSolicitanteId"
                                :disabled="isReadOnly ? true : false"
                                valueField="id"
                                show-default-option
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-1" v-show="item.cotaTipoId == enums.tipoCota.QUANTIDADE">
                            <rkm-form-input
                                label="Cota"
                                v-model="unidadeSolicitante.cotaQuantidade"
                                :validations="item.cotaTipoId == enums.tipoCota.QUANTIDADE ? validations.cotaQuantidade : {}"
                                number
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-1" v-show="item.cotaTipoId != enums.tipoCota.QUANTIDADE">
                            <rkm-form-input
                                label="Cota"
                                ref="unidadeCotaValor"
                                v-model="unidadeSolicitante.cotaValor"
                                :validations="item.cotaTipoId == enums.tipoCota.VALOR ? validations.cotaValor : {}"
                                v-money="money"
                                prepend="R$"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-0" v-if="checkHandleAlter">

                            <rkm-button
                                :label="false"
                                color="secondary"
                                @click.stop="hideAlter()"
                            >
                                Voltar
                            </rkm-button>
                        </rkm-col>

                        <rkm-col class="flex-grow-0" >

                            <rkm-button
                                :label="false"
                                color="primary"
                                @click.stop="handleCota()"
                            >
                                {{ checkHandleAlter ? 'Alterar' : 'Incluir' }}
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <List
                    v-if="!checkHandleAlter"
                    :data="data"
                    :item="item"
                    :unidadeId="item.unidadeId"
                    :infraestruturaId="item.infraestruturaId"
                    :indexLaboratorio="indexLaboratorio"
                    :unidadeSolicitante="item.unidadeSolicitante"
                    :unidadeSolicitantesum="this.unidadeSolicitantesum"
                    :cotaTipoId="this.item.cotaTipoId"
                    @handleAlter="handleAlter"
                    @checkSum="checkSum"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Components.
import List from './List'

// Mixins.
import { repository, object, data, formats } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import tipoCota from '@/enums/exame-laboratorial/tipoCota'

//Directives
import { VMoney } from 'v-money'

export default {
    components: { List },
    directives: { money: VMoney },
    computed: {
        validations() {

            return {
                unidadeSolicitante: { required: true },
                infraestruturasSolicitante: { required: true },
                cotaQuantidade: { required: true },
                cotaValor: { max: 13, min_value: 0.01  },
            }
        },
        hasIndex() {

            return this.index !== null
        },
        infraestruturas() {

            if (this.item.unidadeId) {

                return this.data.form.unidades.find(u => u.id === this.item.unidadeId).infraestruturas
            }

            return []
        },
        infraestruturasSolicitante() {

            if (this.unidadeSolicitante.unidadeSolicitanteId) {

                 let infraestruturaPrincipal =  this.data.form.unidades.find(u =>
                    u.id === this.unidadeSolicitante.unidadeSolicitanteId).infraestruturas

                if (!this.isReadOnly) {

                    this.getPrincipal(infraestruturaPrincipal)
                }

                return infraestruturaPrincipal
            }

            return []
        },
    },
    created() {

        this.repositories = {
            saldo: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }

        this.load()
    },
    data: () => ({
        form: {
            exames: {},
        },
        unidadeSolicitante: {
            unidadeSolicitanteId: null,
            infraestruturaSolicitanteId: null,
            cota: '0',
            cotaValor: '0',
            cotaQuantidade: '0',
            saldo: '0',
            transferencia: '0',
            valorUtilizado: '0',
            quantidadeUtilizada: '0',
            utilizada: '0',
        },
        enums: {
            tipoCota
        },
        model: {
            periodo: {
                start: null,
                end: null
            },
        },
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
        isReadOnly: false,
        checkHandleAlter: false,
        unidadeSolicitantesum: 0,
        index: null,
        cotaOld: null,
        cotaUnidade: null,
        dataInicioUnidade: null,
        dataFimUnidade: null,
        cotasAtribuidas: null,
        cotaAtribuida: null,
        atribuiNovaCota: null,
        limiteCota: false,
        cotaIdUnidadeSolicitante: null,
        addCota: false
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.periodo.start = moment(
                this.item.periodo.start,
                'DD/MM/YYYY'
            ).toDate()

            this.model.periodo.end = moment(
                this.item.periodo.end,
                'DD/MM/YYYY'
            ).toDate()

            this.item.unidadeSolicitante.map(saldo => {

                if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {
                    this.unidadeSolicitantesum = this.unidadeSolicitantesum + this.formatSumMoney(saldo.cota);
                } else {
                    this.unidadeSolicitantesum = this.unidadeSolicitantesum + Number(saldo.cota);
                }
            })
        },
        add() {

            this.resetCotas()

            const hasUnidade = this.item.unidadeSolicitante.find((s) =>
                s.unidadeSolicitanteId === this.unidadeSolicitante.unidadeSolicitanteId
                && s.infraestruturaSolicitanteId === this.unidadeSolicitante.infraestruturaSolicitanteId)

            if (hasUnidade && this.index === null) {

                this.showValidationNotification('Cota já atribuída a unidade solicitante e ao local de atendimento.')
                return false
            }

            this.getCotaAtribuidaExames()

            if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                let cotaValor = this.unidadeSolicitante.cotaValor.replace('.','').replace(',','.')

                let transferencia = this.formatMoney(this.unidadeSolicitante.transferencia)
                transferencia = this.formatSumMoney(transferencia)

                if (this.cotasAtribuidas > 0 && this.cotasAtribuidas > cotaValor) {

                    const unidade = this.data.form.unidades.find(s => s.id === this.item.unidadeId)
                    const infraestrutura = unidade.infraestruturas.find(s => s.id === this.item.infraestruturaId).nome

                    this.showValidationNotification(`A cota é menor que a cota atribuída
                        para as unidades solicitantes em (Parametrização > Cotas
                        > Laboratório > Exames > Unidades solicitantes), para o laboratório <strong>${unidade.nomeFantasia}</strong> e o
                        local de atendimento <strong>${infraestrutura}</strong> no período de
                        <strong>${this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY')}</strong> até
                        <strong>${this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY')}</strong>.
                        A cota deve ser maior ou igual a <strong>R$ ${this.formatMoney(this.cotasAtribuidas,2)}</strong>.
                        `)

                    this.cotasAtribuidas = null

                    return false
                }

                if (transferencia > cotaValor) {

                    const unidade = this.data.form.unidades.find(s => s.id === this.item.unidadeId)
                    const infraestrutura = unidade.infraestruturas.find(s => s.id === this.item.infraestruturaId).nome

                    this.showValidationNotification(`A cota está menor que o valores das cotas
                        transferidas, para o laboratório <strong>${unidade.nomeFantasia}</strong> e o
                        local de atendimento <strong>${infraestrutura}</strong> no período de
                        <strong>${this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY')}</strong> até
                        <strong>${this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY')}</strong>.
                        A cota deve ser maior ou igual a <strong>${this.formatMoney(this.transferencia,2)}</strong>.
                        `)

                    return false
                }

            } else {

                if (this.cotasAtribuidas > 0 && this.cotasAtribuidas > this.unidadeSolicitante.cotaQuantidade) {

                    const unidade = this.data.form.unidades.find(s => s.id === this.item.unidadeId)
                    const infraestrutura = unidade.infraestruturas.find(s => s.id === this.item.infraestruturaId).nome

                    this.showValidationNotification(`A cota é menor que a cota atribuída
                        para as unidades solicitantes em (Parametrização > Cotas
                        > Laboratório > Exames > Unidades solicitantes), para o laboratório <strong>${unidade.nomeFantasia}</strong> e o
                        local de atendimento <strong>${infraestrutura}</strong> no período de
                        <strong>${this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY')}</strong> até
                        <strong>${this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY')}</strong>.
                        A cota deve ser maior ou igual a <strong>${this.formatMoney(this.cotasAtribuidas,0)}</strong>.
                        `)

                    this.cotasAtribuidas = null

                    return false
                }

                if (this.unidadeSolicitante.transferencia > this.unidadeSolicitante.cotaQuantidade) {

                    const unidade = this.data.form.unidades.find(s => s.id === this.item.unidadeId)
                    const infraestrutura = unidade.infraestruturas.find(s => s.id === this.item.infraestruturaId).nome

                    this.showValidationNotification(`A cota está menor que o valores das cotas
                        transferidas, para o laboratório <strong>${unidade.nomeFantasia}</strong> e o
                        local de atendimento <strong>${infraestrutura}</strong> no período de
                        <strong>${this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY')}</strong> até
                        <strong>${this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY')}</strong>.
                        A cota deve ser maior ou igual a <strong>${this.formatMoney(this.unidadeSolicitante.transferencia,0)}</strong>.
                        `)

                    return false
                }
            }

            const unidade = this.data.form.unidades.find(s => s.id === this.item.unidadeId)
            const infraestrutura = unidade.infraestruturas.find(s => s.id === this.item.infraestruturaId).nome

            let utilizadas = this.utilizadas
            let cotaValor = this.unidadeSolicitante.cota

            if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                utilizadas = this.utilizadas.replace('.','').replace(',','.')
                cotaValor = this.unidadeSolicitante.cotaValor.replace('.','').replace(',','.')

                if (parseFloat(utilizadas) > parseFloat(cotaValor)) {

                    this.showValidationNotification(`A cota é menor que a soma dos agendamentos para o laboratório
                        <strong>${unidade.nomeFantasia}</strong> e o local de
                        atendimento <strong>${infraestrutura}</strong> no período de
                        <strong>${this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY')} até
                        ${this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY')}</strong>.
                        A cota deve ser maior ou igual a <strong>R$ ${this.utilizadas}</strong>.
                        `)

                    return false
                }
            } else {

                if (parseFloat(utilizadas) > parseFloat(cotaValor)) {

                    this.showValidationNotification(`A cota é menor que a soma dos agendamentos para o laboratório
                        <strong>${unidade.nomeFantasia}</strong> e o local de
                        atendimento <strong>${infraestrutura}</strong> no período de
                        <strong>${this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY')} até
                        ${this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY')}</strong>.
                        A cota deve ser maior ou igual a <strong>${this.utilizadas}</strong>.
                        `)

                    return false
                }
            }

            let verifyUnidade = this.data.model.cotasUnidadeSolicitante.find(cota =>
                cota.unidadeId == this.unidadeSolicitante.unidadeSolicitanteId
                && cota.infraestruturaId == this.unidadeSolicitante.infraestruturaSolicitanteId)

            if (verifyUnidade) {

                let verifyTipo = verifyUnidade.cotaUnidadeSolicitante.filter((unidade) =>
                    unidade.cotaTipoId == this.item.cotaTipoId
                    && moment(
                        unidade.periodo.start.split("/").reverse().join("-")
                    ).isBetween(
                        this.item.periodo.start.split("/").reverse().join("-"),
                        this.item.periodo.end.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
                    && moment(
                        unidade.periodo.end.split("/").reverse().join("-"),
                    ).isBetween(
                        this.item.periodo.start.split("/").reverse().join("-"),
                        this.item.periodo.end.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
                )

                if (verifyTipo.length) {

                    this.getTotalUnidade()

                    if (!this.limiteCota) {

                        this.showValidationNotification('A cota ultrapassa o limite definido por período para a ' +
                            'unidade solicitante e o local de atendimento.')

                        return false
                    }

                    if (!this.addCota) {

                        this.showValidationNotification('A cota ultrapassa o limite definido por período para a ' +
                            'unidade solicitante e o local de atendimento.')

                        return false
                    }
                }
            }

            const unidadeSolicitante = this.clone(this.unidadeSolicitante)

            unidadeSolicitante.unidadeSolicitante = this.data.form.unidades
                .find(s => s.id === unidadeSolicitante.unidadeSolicitanteId).nomeFantasia

            unidadeSolicitante.infraestruturaNome = this.infraestruturasSolicitante
                .find(s => s.id === unidadeSolicitante.infraestruturaSolicitanteId).nome

            unidadeSolicitante.infraestruturaId = this.infraestruturaId
            unidadeSolicitante.unidadeId = this.unidadeId

            if (this.hasIndex) {

                if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                    this.unidadeSolicitantesum = this.unidadeSolicitantesum - this.formatSumMoney(this.cotaOld);
                } else {

                    this.unidadeSolicitantesum = this.unidadeSolicitantesum - Number(this.cotaOld);
                }

            }

            if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                unidadeSolicitante.cota = this.unidadeSolicitante.cotaValor
            } else {

                unidadeSolicitante.cota = this.unidadeSolicitante.cotaQuantidade
            }

            if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                this.unidadeSolicitantesum = this.unidadeSolicitantesum + this.formatSumMoney(unidadeSolicitante.cota);
            } else {

                this.unidadeSolicitantesum = this.unidadeSolicitantesum + Number(unidadeSolicitante.cota);
            }

            if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                if (this.unidadeSolicitante.cotaValor.length == 0 || this.unidadeSolicitante.cotaValor == '0,00') {

                    this.showValidationNotification('Obrigatório informar a cota e o valor deve ser maior que zero.')

                    return false
                }
            }

            if (this.item.cotaTipoId == this.enums.tipoCota.QUANTIDADE) {

                if (this.unidadeSolicitantesum > this.item.cotaQuantidade) {

                    this.unidadeSolicitantesum = this.unidadeSolicitantesum - Number(unidadeSolicitante.cota);

                    if (this.hasIndex) {

                        this.unidadeSolicitantesum = this.unidadeSolicitantesum + Number(this.cotaOld);
                    }

                    this.showValidationNotification('A cota ultrapassa o limite definido por período para o laboratório.')

                    return false
                }
            }

            if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                if (this.unidadeSolicitantesum > this.formatSumMoney(this.item.cotaValor)) {

                    this.unidadeSolicitantesum = this.unidadeSolicitantesum - this.formatSumMoney(unidadeSolicitante.cota);

                    if (this.hasIndex) {

                        this.unidadeSolicitantesum = this.unidadeSolicitantesum + this.formatSumMoney(this.cotaOld);
                    }

                    this.showValidationNotification('A cota ultrapassa o limite definido por período para o laboratório.')

                    return false
                }
            }

           if (this.hasIndex) {

                this.$set(this.item.unidadeSolicitante, this.index, this.clone(unidadeSolicitante))
                this.index = null
                this.checkHandleAlter = false
            } else {

               this.item.unidadeSolicitante.push(unidadeSolicitante)
            }

            this.$emit('save')

            this.isReadOnly = false

            this.resetForm()

        },
        handleCota() {

            this.setLoading()

            const data = this.item

            this.repositories.saldo.saldoUnidadeSolicitante({
                unidade_id: data.unidadeId,
                infraestrutura_id: data.infraestruturaId,
                inicio: data.periodo.start.split("/").reverse().join("-"),
                fim: data.periodo.end.split("/").reverse().join("-"),
                solicitante_infraestrutura_id: this.unidadeSolicitante.infraestruturaSolicitanteId,
                cota_tipo_id: data.cotaTipoId,
            })
                .then(response => {

                    if (data.cotaTipoId == this.enums.tipoCota.VALOR) {
                        this.unidadeSolicitante.cota = this.unidadeSolicitante.cotaValor
                    } else {
                        this.unidadeSolicitante.cota = this.unidadeSolicitante.cotaQuantidade
                    }

                    this.getCotaUtilizada(response.data)

                    this.$refs.Form.validate(this.add)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getCotaUtilizada(items) {

            if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                this.utilizadas = this.formatMoney(parseFloat(items.valorAgendado), 2)
            } else {

                this.utilizadas = items.quantidadeAgendada
            }
        },
        getTotalUnidade() {

            this.data.model.cotasUnidadeSolicitante.find(cota =>
                cota.unidadeId == this.unidadeSolicitante.unidadeSolicitanteId
                && cota.infraestruturaId == this.unidadeSolicitante.infraestruturaSolicitanteId)
                .cotaUnidadeSolicitante.filter((unidade) =>
                    unidade.cotaTipoId == this.item.cotaTipoId
                    && moment(
                        unidade.periodo.start.split("/").reverse().join("-")
                    ).isBetween(
                        this.item.periodo.start.split("/").reverse().join("-"),
                        this.item.periodo.end.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
                    && moment(
                        unidade.periodo.end.split("/").reverse().join("-"),
                    ).isBetween(
                        this.item.periodo.start.split("/").reverse().join("-"),
                        this.item.periodo.end.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
            ).map(cotaUnidade => {

                if (!this.dataInicioUnidade) {

                    this.dataInicioUnidade = cotaUnidade.periodo.start.split("/").reverse().join("-")
                } else {

                    if (moment(cotaUnidade.periodo.start.split("/").reverse().join("-")).isBefore(this.dataInicioUnidade)) {

                        this.dataInicioUnidade = cotaUnidade.periodo.start.split("/").reverse().join("-")
                    }
                }

                if (!this.dataFimUnidade) {

                    this.dataFimUnidade = cotaUnidade.periodo.end.split("/").reverse().join("-")
                } else {

                    if (moment(cotaUnidade.periodo.end.split("/").reverse().join("-")).isAfter(this.dataFimUnidade)) {

                        this.dataFimUnidade = cotaUnidade.periodo.end.split("/").reverse().join("-")
                    }
                }

                if (this.item.cotaTipoId == this.enums.tipoCota.QUANTIDADE) {

                    if (cotaUnidade.cota) {
                        this.cotaUnidade = this.cotaUnidade + Number(cotaUnidade.cota);
                    }

                } else {

                    if (cotaUnidade.cota) {
                        this.cotaUnidade = this.cotaUnidade + this.formatSumMoney(cotaUnidade.cota);
                    }
                }

                if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                    if (this.cotaUnidade) {

                        if (this.formatSumMoney(this.unidadeSolicitante.cotaValor) <= this.cotaUnidade) {

                            this.limiteCota = true
                            this.cotaIdUnidadeSolicitante = cotaUnidade.id
                        }
                    }

                } else {

                    if (this.cotaUnidade) {

                        if (this.unidadeSolicitante.cotaQuantidade <= this.cotaUnidade) {

                            this.limiteCota = true
                            this.cotaIdUnidadeSolicitante = cotaUnidade.id
                        }
                    }
                }

                if (this.cotaUnidade && this.limiteCota == true && this.addCota == false) {
                    this.getCotaAtribuida()
                }
            })
        },
        getCotaAtribuida() {

            this.cotasAtribuidas = 0
            this.cotaAtribuida = 0

            this.data.model.cotasLaboratorio.map(item => item.cotaLaboratorio.filter(field =>
                field.cotaTipoId == this.item.cotaTipoId
                && moment(

                    field.periodo.start.split("/").reverse().join("-")
                )
                .isBetween(
                    this.dataInicioUnidade,
                    this.dataFimUnidade,
                    null,
                    '[]'
                )
                && moment(
                    field.periodo.end.split("/").reverse().join("-")
                )
                .isBetween(
                    this.dataInicioUnidade,
                    this.dataFimUnidade,
                    null,
                    '[]'
                )
            ).map(unidadeSolicitantes => {

                this.cotaAtribuida = unidadeSolicitantes.unidadeSolicitante.filter(field =>
                    field.unidadeSolicitanteId === this.unidadeSolicitante.unidadeSolicitanteId
                    && field.infraestruturaSolicitanteId === this.unidadeSolicitante.infraestruturaSolicitanteId)
                    .reduce((sum, element) => {

                        if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                            if (element.cota) {

                                sum = sum + this.formatSumMoney(element.cota);
                            }
                        } else {

                            if (element.cota) {

                                sum = Number(sum) + Number(element.cota);
                            }
                        }

                        return sum
                    },0)

                    if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                        this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                    } else {
                        this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                    }
            }))

            if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                if (this.hasIndex) {

                    this.atribuiNovaCota = (this.cotasAtribuidas + this.formatSumMoney(this.unidadeSolicitante.cotaValor)) - this.formatSumMoney(this.cotaOld)

                } else {

                    this.atribuiNovaCota = this.cotasAtribuidas + this.formatSumMoney(this.unidadeSolicitante.cotaValor)
                }

            } else {

                if (this.hasIndex) {

                    this.atribuiNovaCota = (this.cotasAtribuidas + Number(this.unidadeSolicitante.cotaQuantidade)) - Number(this.cotaOld)

                } else {


                    this.atribuiNovaCota = this.cotasAtribuidas + Number(this.unidadeSolicitante.cotaQuantidade)
                }
            }

            if (this.cotaUnidade >= this.atribuiNovaCota) {
                this.addCota = true
            }
        },
        getCotaAtribuidaExames() {

            this.cotasAtribuidas = 0
            this.cotaAtribuida = 0

            Object.keys(this.item.exames).forEach(c => {

                this.cotaAtribuida = this.item.exames[c].unidadeSolicitante.filter(field =>
                    field.unidadeSolicitanteId === this.unidadeSolicitante.unidadeSolicitanteId
                    && field.infraestruturaSolicitanteId === this.unidadeSolicitante.infraestruturaSolicitanteId
                )
                .reduce((sum, element) => {

                    if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                        if (element.cota) {

                            sum = sum + this.formatSumMoney(element.cota);
                        }

                    } else {

                        if (element.cota) {

                            sum = Number(sum) + Number(element.cota);
                        }
                    }

                    return sum
                },0)

                if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                    this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                } else {

                    this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                }

            })
        },
        handleAlter(item) {

            this.resetForm()

            this.index = this.item.unidadeSolicitante.findIndex((s) =>
                s.unidadeSolicitanteId === item.unidadeSolicitanteId
                && s.infraestruturaSolicitanteId === item.infraestruturaSolicitanteId)

            this.unidadeSolicitante.unidadeSolicitanteId = item.unidadeSolicitanteId
            this.unidadeSolicitante.infraestruturaSolicitanteId = item.infraestruturaSolicitanteId
            this.unidadeSolicitante.cotaQuantidade = item.cotaQuantidade
            this.unidadeSolicitante.cotaValor = item.cotaValor
            this.unidadeSolicitante.transferencia = item.transferencia
            this.unidadeSolicitante.valorUtilizado = item.valorUtilizado
            this.unidadeSolicitante.quantidadeUtilizada = item.quantidadeUtilizada

            if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                this.cotaOld = item.cotaValor
            } else {

                this.cotaOld = item.cotaQuantidade
            }

            this.$refs.unidadeCotaValor.$el.getElementsByTagName('input')[0].value = item.cotaValor;

            this.isReadOnly = true
            this.checkHandleAlter = true
        },
        hideAlter() {

            this.isReadOnly = false
            this.checkHandleAlter = false

            this.resetForm()
        },
        checkSum() {

            this.unidadeSolicitantesum = 0

            this.item.unidadeSolicitante.map(saldo => {

                if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                    this.unidadeSolicitantesum = this.unidadeSolicitantesum + this.formatSumMoney(saldo.cota);
                } else {

                    this.unidadeSolicitantesum = this.unidadeSolicitantesum + Number(saldo.cota);
                }
            })
        },
        hasUnidadeParametrizada() {

            return this.data.model.cotasExamePeriodo.find((unidade, i) => i !== this.index
                && unidade.exameId == this.model.exameId && unidade.ano == this.model.ano)
        },
        handleDestroy(index, item) {

            const destroy = async () => {

                this.unidadeSolicitante.splice(index, 1)
            }

            this.showDeleteConfirmation(`Deseja realmente excluir a cota para a
                <strong>${ item.unidadeSolicitante }</strong>?`,
                destroy)
        },
        resetForm() {

            this.index = null
            this.unidadeSolicitante.unidadeSolicitanteId = null
            this.unidadeSolicitante.infraestruturaSolicitanteId = null
            this.unidadeSolicitante.cotaValor= ''
            this.$refs.unidadeCotaValor.$el.getElementsByTagName('input')[0].value = 0;
            this.unidadeSolicitante.cotaQuantidade= ''

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },        
        getPrincipal(infraestruturaPrincipal) {

            if (infraestruturaPrincipal.find(u => u.principal === true)) {
                this.unidadeSolicitante.infraestruturaSolicitanteId = infraestruturaPrincipal.find(u => u.principal === true).id
            } else {
                this.unidadeSolicitante.infraestruturaSolicitanteId = null
            }
        },
        resetCotas() {
            this.cotaUnidade = null
            this.cotasAtribuidas = null
            this.cotaAtribuida = null
            this.limiteCota = false,
            this.cotaIdUnidadeSolicitante = null,
            this.addCota = false
        }
    },
    mixins: [repository, object, data, formats],
    props: {
        data: { type: Object, required: true },
        item: { type: Object, required: true },
        indexLaboratorio: { type: [Number, String], required: true },
    },
}
</script>